import { Component } from '@angular/core';

@Component({
  templateUrl: './overlay-loader.component.html',
  styleUrls: ['./overlay-loader.component.scss'],
  standalone: false,
})
export class IrisOverlayLoaderComponent {}
